module.exports = __webpack_public_path__ + "static/media/utensils-alt.893f47b1.svg";